<template>
  <TransitionRoot as="template" :show="show">
    <Dialog class="relative z-50" @close="emit('cancel')">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div :tabindex="1" class="fixed inset-0 bg-gray-500/75 transition-opacity" />
      </TransitionChild>

      <div id="dialogContent" class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0"
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              :class="[
                Capacitor.getPlatform() === 'ios' ? 'notch-margin' : '',
                `relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full ${maxWidth} sm:p-6 sm:px-6 lg:px-8`
              ]"
            >
              <div>
                <div class="flex items-center justify-between">
                  <div>
                    <HeaderComponent v-if="title !== undefined" :title :heading="3" :text="text" />
                  </div>
                  <ButtonComponent
                    type="transparent"
                    :icon="['fal', 'xmark']"
                    class="!p-0 !pb-4 !pt-2"
                    @clicked="emit('close')"
                  />
                </div>

                <section aria-labelledby="summary-heading" class="w-full space-y-4">
                  <slot name="main"></slot>
                </section>

                <div
                  v-if="acceptText !== undefined || cancelText !== undefined"
                  class="mt-8 flex flex-col justify-end space-y-2 sm:flex-row sm:space-x-2 sm:space-y-0"
                >
                  <ButtonComponent
                    v-if="acceptText !== ''"
                    :text="acceptText"
                    :type="acceptButtonType"
                    :is-loading="isLoading"
                    class="w-full sm:w-auto"
                    @clicked="emit('accepted')"
                  />
                  <ButtonComponent
                    v-if="cancelText !== ''"
                    :text="cancelText"
                    class="w-full sm:w-auto"
                    :type="cancelButtonType"
                    @clicked="emit('cancel')"
                  />
                </div>
                <slot name="footer"></slot>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script setup lang="ts">
import { Capacitor } from '@capacitor/core'
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'

const emit = defineEmits(['accepted', 'cancel', 'close'])

const {
  title = '',
  text = '',
  cancelText = '',
  acceptText = '',
  cancelButtonType = 'outline',
  acceptButtonType = '',
  show,
  isLoading = false,
  maxWidth = 'sm:max-w-lg'
} = defineProps<{
  title?: string
  text?: string
  cancelText?: string
  acceptText?: string
  cancelButtonType?: string
  acceptButtonType?: string
  show: boolean
  isLoading?: boolean
  maxWidth?: string
}>()
</script>
